'use client'
import { ExternalLink } from '@morpho-org/ui-v6/server'
import { Button, Icon } from '@repo/ui'
import { Alert, Morpho } from '@repo/ui/icons'

import { HELP_CENTER_URL } from '@/config'

const ProviderError = () => {
  return (
    <div className="gap-lg flex h-[100vh] w-[100vw] grow flex-col items-center justify-center">
      <div className="gap-sm flex flex-col items-center justify-center">
        <Icon className="size-[46px]" icon={<Morpho />} />
        <div className="gap-lg flex max-w-[400px] grow flex-col items-center justify-center">
          <div className="gap-sm flex flex-col items-center justify-center">
            <div className="flex items-center gap-[6px]">
              <Icon className="text-foreground size-[28px]" icon={<Alert />} />
              <span className="text-title-xs">Oops! Something went wrong.</span>
            </div>
            <span className="text-sm" style={{ textAlign: 'center' }}>
              We&apos;re sorry for the inconvenience. If the issue persists, please reach out to our
              support team on{' '}
              <ExternalLink href={HELP_CENTER_URL} underlined>
                Help Center
              </ExternalLink>
              .
            </span>
          </div>

          <Button variant="secondary" onClick={() => window.location.reload()}>
            Reload page
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ProviderError
